import ProjectApi from '~/common/api/zeiterfassungServerApi/ProjectApi';
import { Project } from '~/common/entities/Project/ProjectTypes';
import React from 'react';

export const useDeleteProject = (project: Project) => {
  const [confirmOpen, setConfirmOpen] = React.useState(false);
  const { mutateAsync: deleteProjectMutation } =
    ProjectApi.hooks.useDeleteProjectMutation();
  const deleteProject = () => {
    return deleteProjectMutation(project).then(() => setConfirmOpen(false));
  };
  return {
    confirmOpen,
    setConfirmOpen,
    deleteProject,
  };
};

export const useCopyProject = (project: Project) => {
  const [copyOpen, setCopyOpen] = React.useState(false);
  const { mutateAsync: copyProjectMutation } =
    ProjectApi.hooks.useDuplicateProjectMutation();
  const copyProject = (values: { newName: string }) => {
    return copyProjectMutation({
      new_name: values.newName,
      id: project.id,
    }).then(() => setCopyOpen(false));
  };
  return {
    copyOpen,
    setCopyOpen,
    copyProject,
  };
};
